export const SET_MODAL = 'SET_MODAL';
export const UNSET_MODAL = 'UNSET_MODAL';